const SET_NEWS = "SET_NEWS";
let initialState = {
  news: [],
};
const NewsPreviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NEWS: {
      let stateCopy = { ...state };
      stateCopy.news = Array.isArray(action.news) ? action.news : [];
      return stateCopy;
    }
    default:
      return state;
  }
};
export const setNews = (news) => ({ type: SET_NEWS, news });
export default NewsPreviewReducer;
